import { render, staticRenderFns } from "./AppDaemonBadge.vue?vue&type=template&id=d2263fb4&scoped=true"
import script from "./AppDaemonBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppDaemonBadge.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppDaemonBadge.vue?vue&type=style&index=0&id=d2263fb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2263fb4",
  null
  
)

export default component.exports